import { Component } from "react";
import { ErrorState } from "@/sentinel";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error("Sentinel page error:", error, info);
  }
  reset = () => this.setState({ error: null });
  render() {
    if (this.state.error) {
      return (
        <div data-testid="error-boundary">
          <ErrorState title="This screen failed to render" detail={String(this.state.error?.message || this.state.error)} onRetry={this.reset}>
            The failure is contained to this screen; the rest of Sentinel is unaffected. Sealed checkpoints are not changed.
          </ErrorState>
        </div>
      );
    }
    return this.props.children;
  }
}
